import "../../utils/tailwind.css";
import cx from "../../utils/tailwind-merge";

export default function Label(props) {
  const { className = "", label = "", isRequired = false } = props;
  return (
    <div className={cx("text-[13px] text-[#686868] mb-3", className)}>
      {label}
      {isRequired && <span className="text-red-500">*</span>}
    </div>
  );
}
